<div class="folder folder--blue">
  {{ folderType | titlecase }}
</div>
